import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['nav', 'panel'];

  initialize() {
    this.isOpen = false;
    this._setWindowListener();
  }

  toggle(event = null) {
    if (event) {
      event.stopPropagation();
    }

    this.panelTargets.forEach((el) => el.classList.toggle('u-displayNone'));
    this.navTarget.classList.toggle('is-open');
    this.isOpen = !this.isOpen;
  }

  _listener(e) {
    if (this.isOpen && !e.target.closest('[data-target~="navigation.nav"')) {
      this.toggle();
    }
  }

  _setWindowListener() {
    window.addEventListener('click', this._listener.bind(this));
  }
}
